<div class="acquisition-container">
  <h2 class="page-title">Aquisição de Moedas/Gemas</h2>

  <div class="filter-bar">
    <div class="date-fields">
      <div class="date-field">
        <label for="acquisition-since">Data inicial</label>
        <p-datepicker inputId="acquisition-since" dateFormat="dd/mm/yy" [(ngModel)]="since" [readonlyInput]="true"
          placeholder="Selecione a data inicial" />
      </div>

      <div class="date-field">
        <label for="acquisition-until">Data final</label>
        <p-datepicker inputId="acquisition-until" dateFormat="dd/mm/yy" [(ngModel)]="until" [readonlyInput]="true"
          placeholder="Selecione a data final" />
      </div>

      <button class="btn-pesquisar" (click)="applyDateFilter()" [disabled]="isLoading">Filtrar</button>
    </div>

    <div class="action-buttons">
      <button class="btn-export" (click)="exportToCsv()" [disabled]="isLoading || !rows.length">
        Exportar CSV
      </button>
      <button class="btn-refresh" (click)="refresh()" [disabled]="isLoading" title="Atualizar">
        <i class="pi pi-refresh"></i>
      </button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <section class="summary-grid">
    <article class="summary-card coin-card">
      <span class="summary-label">Moedas adquiridas</span>
      <strong>{{ summary.coin.total | number: '1.0-0' }}</strong>
      <small>{{ summary.coin.sources.length || 0 }} origens no período.</small>
    </article>

    <article class="summary-card gem-card">
      <span class="summary-label">Gemas adquiridas</span>
      <strong>{{ summary.gem.total | number: '1.0-0' }}</strong>
      <small>{{ summary.gem.sources.length || 0 }} origens no período.</small>
    </article>
  </section>

  <section class="source-panels">
    <article class="source-panel">
      <div class="source-panel__header">
        <h3>Origens de moedas</h3>
        <span>Total: {{ summary.coin.total | number: '1.0-0' }}</span>
      </div>

      <div class="source-list" *ngIf="summary.coin.sources.length; else emptyCoinSources">
        <div *ngFor="let source of summary.coin.sources; trackBy: trackSource" class="source-row">
          <div>
            <strong>{{ source.label }}</strong>
            <small>{{ source.transactions_count }} transações</small>
          </div>
          <span>{{ source.amount | number: '1.0-0' }}</span>
        </div>
      </div>

      <ng-template #emptyCoinSources>
        <p class="empty-panel">Nenhuma aquisição de moedas no período.</p>
      </ng-template>
    </article>

    <article class="source-panel">
      <div class="source-panel__header">
        <h3>Origens de gemas</h3>
        <span>Total: {{ summary.gem.total | number: '1.0-0' }}</span>
      </div>

      <div class="source-list" *ngIf="summary.gem.sources.length; else emptyGemSources">
        <div *ngFor="let source of summary.gem.sources; trackBy: trackSource" class="source-row">
          <div>
            <strong>{{ source.label }}</strong>
            <small>{{ source.transactions_count }} transações</small>
          </div>
          <span>{{ source.amount | number: '1.0-0' }}</span>
        </div>
      </div>

      <ng-template #emptyGemSources>
        <p class="empty-panel">Nenhuma aquisição de gemas no período.</p>
      </ng-template>
    </article>
  </section>

  <p-table [value]="rows" [loading]="isLoading" [paginator]="true" [rows]="15" [rowsPerPageOptions]="[15, 30, 60]">
    <ng-template pTemplate="header">
      <tr>
        <th>Data</th>
        <th>Moedas adquiridas</th>
        <th>Origens de moedas</th>
        <th>Gemas adquiridas</th>
        <th>Origens de gemas</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="date-cell">{{ row.date | date: 'dd/MM/yyyy' }}</td>
        <td>{{ row.coin.total | number: '1.0-0' }}</td>
        <td>
          <div class="compact-source-list" *ngIf="row.coin.sources.length; else noCoinDaySources">
            <span *ngFor="let source of row.coin.sources; trackBy: trackSource">
              {{ source.label }}: {{ source.amount | number: '1.0-0' }}
            </span>
          </div>
          <ng-template #noCoinDaySources>—</ng-template>
        </td>
        <td>{{ row.gem.total | number: '1.0-0' }}</td>
        <td>
          <div class="compact-source-list" *ngIf="row.gem.sources.length; else noGemDaySources">
            <span *ngFor="let source of row.gem.sources; trackBy: trackSource">
              {{ source.label }}: {{ source.amount | number: '1.0-0' }}
            </span>
          </div>
          <ng-template #noGemDaySources>—</ng-template>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="empty-message">Nenhum dado encontrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
